<template>
  <footer class="site-footer">
    <affiliate />
    <!-- <aside class="agent" v-if="affiliate != 'null'">
      <div class="agent-wrap">
        <div class="agent-card">
          <div class="agent-figure">
            <img :src="affiliate.photo_url">
          </div>
          <div class="agent-meta">
            <p>
              <span>
                ตัวแทนผู้รับผิดชอบ
                <span v-text="affiliate.name"/>
              </span>
              <span class="inline">ใบอนุญาตเลขที่ {{ affiliate.card_id }}</span>
              <span class="inline">วันที่หมดอายุ {{ affiliate.card_exp }}</span>
            </p>
          </div>
        </div>
      </div>
    </aside> -->

    <div class="footer-block">
      <div class="grid">
        <div class="footer-logo col-1-1">
          <div class="logo--footer" itemprop="logo">724 Market</div>
        </div>
        <div class="col-2-3">
          <div class="footer-contact grid">
            <div class="center--service col-1-1">
              <div class="contact">
                <h6>ติดต่อศูนย์บริการลูกค้า</h6>
                <h6>ติดต่อ Call Center ได้ตลอดเวลา 7 วัน 24 ชม.</h6>
              </div>
              <div class="address">
                <p>บริษัท 724 มาร์เก็ต จำกัด (ศูนย์บริการลูกค้า)</p>
                <p>เปิดให้บริการทุกวัน</p>
                <p>ห้องเลขที่ 65/44 ชั้น3 อาคารชำนาญเพ็ญชาติบิสเนส เซ็นเตอร์</p>
                <p>ถนนพระราม 9 แขวงห้วยขวาง เขตห้วยขวาง</p>
                <p>กรุงเทพฯ 10310</p>
              </div>
            </div>
            <div class="center--condition border-top col-1-1">
              <ul class="condition">
                <li>
                  <a :href="url_insure+'/term-conditions'" target="_blank">เงื่อนไขและข้อกำหนด</a>
                </li>
                <li>
                  <a :href="url_insure+'/privacy-policy'" target="_blank">ความเป็นส่วนตัวและข้อมูลส่วนบุคคล</a>
                </li>
                <li>
                  <a :href="url_insure+'/coverage'" target="_blank">เงื่อนไขและข้อยกเว้นการทำประกัน</a>
                </li>
              </ul>
            </div>
            <div class="contact-payment border-top col-1-1">
              <h6>ช่องการชำระเงิน</h6>
              <div class="payment">
                <div class="payment-media">
                  <div class="payment-media-size">
                    <img src="assets/img/kbank.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/bbl.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/scb.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/krungsri.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/tbank.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/uob.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/citi.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/ktc.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/mastercard.png" />
                  </div>
                  <div class="payment-media-size">
                    <img src="assets/img/visa.png" />
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-social border-top col-1-1">
              <div class="social">
                <h6>ช่องทางการติดตาม</h6>
                <div class="u--social">
                  <a class="u--mobile" href="tel:028673800">
                    <span class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fas fa-mobile-alt fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <a class="u--facebook" href="https://www.facebook.com/724insure">
                    <span class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fab fa-facebook fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                  <a class="u--line" href="https://line.me/R/ti/p/%40724insure">
                    <span class="fa-stack">
                      <i class="fas fa-circle fa-stack-2x"></i>
                      <i class="fab fa-line fa-stack-1x fa-inverse"></i>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-certification">
      <div class="container">
        <div class="grid">
          <div class="certification-standard">
            <h6>มาตรฐานการรับรอง</h6>
            <div class="standard">
              <div class="standard-item">
                <a
                  title="ใบอนุญาตการเสนอขายกรมธรรม์ประกันภัยผ่านทางอิเล็กทรอนิกส์ (Online)"
                  @click="btnonlinecertificate()"
                >
                  <img class="standard-media" src="uploads/oic-online.png" />
                </a>
              </div>
              <div class="standard-item">
                <a title="ใบอนุญาตเป็นนายหน้าประกันวินาศภัย" @click="btncertificate()">
                  <img class="standard-media" src="uploads/oic.png" />
                </a>
              </div>
              <div class="standard-item">
                <a
                  target="_blank"
                  href="https://www.trustmarkthai.com/callbackData/popup.php?data=ac637e8-33-5-7f4cf5b6c3899dd860a5d7086f31631097b3d0&amp;markID=firstmark"
                  title="ใบอนุญาตการเสนอขายกรมธรรม์ประกันภัยผ่านทางอิเล็กทรอนิกส์ (Online)"
                >
                  <img class="standard-media" src="uploads/dbd.png" />
                </a>
              </div>
              <div class="standard-item">
                <img class="standard-media" src="uploads/ibathai.png" />
              </div>
              <div class="standard-item">
                <img class="standard-media" src="uploads/geotrust.png" />
              </div>
            </div>
          </div>
          <div class="certification-copyright">
            <div class="copyright">
              <p>ใบอนุญาเลขที่ ว00003/2549</p>
              <p>© 724.co.th</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modalcertificate v-show="btncertificate_active" />
    <modalonlinecertificate v-show="btnonlinecertificate_active" />
  </footer>
</template>

<script>
// import axios from "axios";
// import { mapGetters } from "vuex";
import modalcertificate from '@/components/modal/certificate'
import modalonlinecertificate from '@/components/modal/onlinecertificate'
import affiliate from '@/components/Affiliate'
export default {
  components: {
    modalcertificate,
    modalonlinecertificate,
    affiliate
  },
  data() {
    return {
        url_insure: main_url_insure,
      btncertificate_active: false,
      btnonlinecertificate_active: false
    }
  },
  computed: {
      // ...mapGetters(['currentUrl'])
    // ...mapState({ affiliate: state => state.affiliate }),
    // ...mapState({ codeaffiliate: state => state.codeaffiliate })
  },
  methods: {
    // ...mapActions({ getSetAffiliate: "getSetAffiliate" }),
    // ...mapActions({ CreatecodeAffiliate: "CreatecodeAffiliate" }),
    // copybutton() {
    //   //alert("ssss");
    //   new Clipboard(".copy-text");

    //   $("#copy-status").show();

    //   $(".copy-text").addClass("copied");
    // },
    btnonlinecertificate() {
      //alert("btnonlinecertificate");
      var btnonlinecertificate = $('#modal-online-certificate')
        .mobiscroll()
        .popup({
          display: 'center',
          buttons: [],
          layout: 'liquid'
        })
        .mobiscroll('getInst')
      this.btnonlinecertificate_active = true

      btnonlinecertificate.show()
    },
    btncertificate() {
      //alert("btncertificate");
      var btncertificate = $('#modal-certificate')
        .mobiscroll()
        .popup({
          display: 'center',
          buttons: [],
          layout: 'liquid'
        })
        .mobiscroll('getInst')
      this.btncertificate_active = true
      btncertificate.show()
    }
  },
  async mounted() {
    // let agent_code = this.$route.query.u == 'undefined' ? '' : this.$route.query.u
    // console.log("U is "+this.$route.query.u)
    // let uri = window.location.search.substring(1);
    // let params = new URLSearchParams(uri);
    // alert(params.get('u'))
    // alert(params.get('utm_source'))
    // alert(params.get('utm_medium'))
    // alert(params.get('utm_term'))
    // let agent_code = params.get("u");
    // await this.getSetAffiliate(agent_code);
    // let dataAff = { pamalink: this.$route.params.pamalink };
    // await this.CreatecodeAffiliate(JSON.stringify(dataAff));
    // await axios
    //   .get("https://share.724insure.net/get_share_url/" + this.codeaffiliate)
    //   .then(res => {
    //     this.urlshare.url_affiliate = res.data.url_affiliate;
    //     this.urlshare.url_affiliate_status = res.data.url_affiliate_status;
    //     this.urlshare.url_facebook = res.data.url_facebook;
    //     this.urlshare.url_line = res.data.url_line;
    //   })
    //   // eslint-disable-next-line
    //   .catch(error => console.log(error));
  }
}
</script>

<style>
</style>